import { legacy_createStore as createStore, applyMiddleware, compose } from 'redux';
import ReduxThunk from 'redux-thunk';
import reduxCatch from 'redux-catch';
import createSagaMiddleware from 'redux-saga';
import reducers from '../reducers';
import { LOCAL_ENVIRONMENT, PROD_ENVIRONMENT } from 'constants/index';
import sagas from 'sagas';
import timeStamp from '../middlewares/timeStamp';
import { middlewaresErrorsHandler } from '../middlewares/middlewaresErrorsHandler';

const sagaMiddleware = createSagaMiddleware();

const enhancers = compose(
    applyMiddleware(reduxCatch(middlewaresErrorsHandler), timeStamp, ReduxThunk, sagaMiddleware),
    window.__REDUX_DEVTOOLS_EXTENSION__ && __ENV__ !== PROD_ENVIRONMENT ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
);

const store = createStore(reducers, enhancers);

// Running sagas
for (let saga of sagas) {
    sagaMiddleware.run(saga);
}

// For DEVELOPMENT we want to avoid a continous logout
if (__ENV__ === LOCAL_ENVIRONMENT) {
    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('../reducers', () => {
            const nextReducer = require('../reducers');
            store.replaceReducer(nextReducer);
        });
    }
}

export default {
    store,
};
